import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store/rootStore'
import AppRouter from './Router'
import { CssBaseline, ThemeProvider } from '@mui/material'
import theme from './themes'
import { Loader } from './components/Loader'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from './util/useToast'
import { OnlineStatusProvider } from './util/useOnlineStatus'
import { toast } from 'react-toastify'
import { useServiceWorker } from './useServiceWorker'
import './native/utils/SafeArea'
import { Capacitor } from '@capacitor/core'

import { SplashScreen } from '@capacitor/splash-screen'
import './services/firebase'
import './services/sentry'

// Hide the splash (you should do this on app launch)
function App() {
  if (Capacitor.isNativePlatform()) {
    SplashScreen.hide()
  } else if (!Capacitor.isNativePlatform()) {
    const { waitingWorker, showReload, reloadPage } = useServiceWorker()
    useEffect(() => {
      if (showReload && waitingWorker) {
        toast.onChange((e) => {
          if (e.id === 'reload' && e.status === 'removed') {
            reloadPage()
          }
        })
        toast('Reload for latest version', {
          autoClose: false,
          toastId: 'reload',
          closeButton: (
            // Must be manually styled as it sits outside of MuiTheme context.
            <button onClick={() => reloadPage()} className='toast-refresh-button'>
              Refresh
            </button>
          ),
        })
      }
    }, [waitingWorker, showReload, reloadPage])
  }

  return (
    <OnlineStatusProvider>
      <ThemeProvider theme={theme()}>
        <Provider store={store}>
          <PersistGate persistor={persistor} loading={<Loader title='Launching' />}>
            <ToastContainer />
            <CssBaseline />
            <AppRouter />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </OnlineStatusProvider>
  )
}

export default App
